import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const AppSidebarBtm = ({ sidebarShow }) => {

    const [userData, setUserData] = useState(false);

    useEffect(() => {
        if (!userData) {
            setUserData(JSON.parse(localStorage.getItem('user_data')));
        }
    }, [userData])

    return (
        userData &&
        <Link to={'/users/update/' + userData.id} className="bottom-sidebar">
            <div className="sidebar-user">
                <div className="sidebar-user__logo">
                    {/* <img src="/logo.svg" alt="logo" /> */}
                    <p>{userData.first_name[0]}</p>
                </div>
                {sidebarShow ? <div className="sidebar-user__descr">
                    <div className="name">
                        {userData.first_name}
                    </div>
                    <div className="role">
                        {userData.roles.map((role, index) => {
                            return <span key={index}>{role}</span>
                        })}
                    </div>
                </div> : ''}

            </div>
            {sidebarShow && <img src="/chevron.svg" alt="chevron" width={20} height={20} />}
        </Link>
    );
}